export const reportKeys = {
    all: ["reports"] as const,
};